<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" fab depressed small>
        <v-icon>mdi-pencil-outline</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-form ref="formAddress" v-model="valid" lazy-validation>
        <v-toolbar flat>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{
            $t("profileDialogAddressTitle")
          }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-text-field
            v-model="cep"
            :loading="isLoading"
            :label="$t('profileDialogAddressPostal')"
            :rules="zipCodeRules"
            type="number"
            mask="#####-###"
            outlined
            required
          ></v-text-field>
          <v-text-field
            v-model="address.endereco"
            :label="$t('profileDialogAddressHomeAddress')"
            :loading="isLoading"
            :rules="[rules.required, rules.max]"
            outlined
            required
          ></v-text-field>
          <v-text-field
            v-model="address.numero"
            :label="$t('profileDialogAddressNumber')"
            :rules="[rules.required, rules.max]"
            type="number"
            outlined
            required
          ></v-text-field>
          <v-text-field
            v-model="address.bairro"
            :label="$t('profileDialogAddressDistrict')"
            :loading="isLoading"
            :rules="[rules.required, rules.max]"
            outlined
            required
          ></v-text-field>
          <v-text-field
            v-model="address.complemento"
            :label="$t('profileDialogAddressComplement')"
            :rules="[rules.max]"
            outlined
          ></v-text-field>
          <v-select
            v-model="statesRules.selectState.id"
            :label="$t('profileDialogAddressEstado')"
            :items="id_state"
            :rules="[rules.required]"
            :loading="isLoading"
            item-value="id"
            item-text="nome"
            outlined
            required
          ></v-select>
          <v-select
            v-model="cityRules.selectCity.id"
            :label="$t('profileDialogAddressCity')"
            :items="id_city"
            :rules="[rules.required]"
            :loading="isLoading"
            item-text="nome"
            item-value="id"
            outlined
            required
          ></v-select>
        </v-card-text>

        <v-card-actions class="pa-5">
          <div class="flex-grow-1"></div>
          <v-btn text outlined="" @click="dialog = false">
            {{ $t("BtnCancel") }}
          </v-btn>
          <v-btn
            depressed
            color="primary"
            type="submit"
            @click.prevent="editUser"
            :disabled="!valid"
            :loading="loading"
          >
            {{ $t("BtnSave") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import qs from "qs";
import { validate } from "@/util/form-validate.js";

export default {
  name: "dialogEditAdress",
  props: ["address"],
  data: () => ({
    isLoading: false,
    loading: false,
    dialog: false,
    dialogTitle: "Dados de Localização",
    valid: false,

    // Form 3 - Info Address:
    cep: "",
    id_state: [],
    id_city: [],

    // Rules Default Import
    rules: {
      required: validate.required,
      phoneCounter: validate.phoneCounter,
      max: validate.max,
    },
    zip_codeRules: {
      required: "Este campo é obrigatório.",
      max: 8,
      check: "",
    },
    statesRules: {
      selectState: [],
    },
    cityRules: {
      selectCity: [],
      cityApiCep: "",
    },
  }),
  mounted() {
    this.cep = this.address.cep;
    // this.getStates();
    // this.getCity();
  },
  computed: {
    // Rules ZipCode
    zipCodeRules() {
      const rules = [];
      // * Required
      if (this.zip_codeRules.required) {
        const rule = (v) => !!v || this.zip_codeRules.required;
        rules.push(rule);
      }
      // Required 11 caracteres
      if (this.zip_codeRules.max) {
        const rule = (v) =>
          (v && v.length) === this.zip_codeRules.max ||
          `O CEP deve conter ${this.zip_codeRules.max} números`;
        rules.push(rule);
      }
      // CEP Encontrado ou Não Encrontrado
      if (this.zip_codeRules.check === 1) {
        rules.push(true);
      } else if (this.zip_codeRules.check === 0) {
        rules.push("CEP não encontrado");
      }
      return rules;
    },
  },
  watch: {
    "address.cep"(val) {
      this.cep = val;
    },

    dialog(val) {
      !val && this.$emit("refresh-user");
    },

    cep: function(newCep) {
      if (newCep && newCep.length >= 8) {
        let cep = newCep;
        let formatCep = cep.replace(/[^0-9]+/g, ""); // tira todos os caracteres menos os números;
        let data = {
          cep: formatCep,
        };
        this.getApiCEP(data);
      }
    },
  },
  methods: {
    // GET CEP
    getApiCEP(cep) {
      this.isLoading = true;
      this.$axios
        .post("player/register/fetchCep", this.$formdata(cep))
        .then((response) => {
          let dados = response.data.dados;
          this.zip_codeRules.check = 1;

          const uf = dados.uf;
          this.getStates(uf);
          this.address.endereco = dados.logradouro
            ? `${dados.logradouro}`
            : `${dados.label}`;
          this.address.bairro = dados.bairro
            ? `${dados.bairro}`
            : `${dados.cidade}`;
          this.cityRules.cityApiCep = dados.cidade;
        })
        .catch(() => {
          this.zip_codeRules.check = 0;
          const msg =
            "Algo deu errado, se o erro persistir entre em contato com nosso suporte.";
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        })
        .finally(() => (this.isLoading = false));
    },

    // GET STATES
    getStates(uf) {
      this.$axios
        .post("player/register/fetchStates")
        .then((response) => {
          const dados = response.data.dados;
          this.id_state = dados;
          for (let item in dados) {
            if (dados[item].uf === uf) {
              this.statesRules.selectState = dados[item];
              this.getCity(dados[item].id);
              break;
            }
          }
        })
        .catch(this.NotificationErrorDefault);
    },

    // GET CITY
    getCity(stateId) {
      const data = {
        id_state: stateId,
      };
      const cidade = this.cityRules.cityApiCep;
      this.$axios
        .post("player/register/fetchCities", this.$formdata(data))
        .then((response) => {
          const dados = response.data.dados;
          this.id_city = dados;
          for (let item in dados) {
            if (dados[item].nome == cidade) {
              this.cityRules.selectCity = dados[item];
              break;
            }
          }
        })
        .catch(this.NotificationErrorDefault);
    },

    // Edit User - Dados Endereço
    editUser() {
      if (this.$refs.formAddress.validate()) {
        this.loading = true;
        const params = "player/profile/editPlayer";
        const data = {
          etapa: "Endereco",
          cep: this.cep,
          endereco: this.address.endereco,
          numero: this.address.numero,
          bairro: this.address.bairro,
          complemento: this.address.complemento,
          id_estado: this.statesRules.selectState.id,
          id_municipio: this.cityRules.selectCity.id,
        };
        this.$axios
          .put(params, qs.stringify(data), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
          .then((response) => {
            const msg = response.data.messages;
            const color = "green";
            this.$store.commit("setNotification", { msg, color });
          })
          .then(() => {
            // Register Event add_shipping_info Analytics
            this.$gtag.add_shipping_info({
              cep: this.cep,
              endereco: this.address.endereco,
              bairro: this.address.bairro,
              id_estado: this.statesRules.selectState.id,
              estado: this.statesRules.selectState.nome,
              id_municipio: this.cityRules.selectCity.id,
            });
          })
          .then(() => {
            this.dialog = false;
          })
          .catch(this.NotificationErrorDefault)
          .finally(() => (this.loading = false));
      } else {
        const msg = "Existe erro(s) no formulário, revise suas informações.";
        const color = "warning";
        this.$store.commit("setNotification", { msg, color });
      }
    },

    // Notification Error Default
    NotificationErrorDefault(error) {
      const msg = error.response.data.messages[0];
      const color = "warning";
      this.$store.commit("setNotification", { msg, color });
    },
  },
};
</script>
